import React from 'react';
import Button from '../button';
import Modal from '../modal';

interface IDeleteModal {
    openDeleteModal: boolean;
    handleCloseDeleteModal: () => void;
    onApproveDeletion: () => void;
    title?: string;
    message?: string;
    isLoading?: boolean;
}

const DeleteModal = ({
    openDeleteModal,
    handleCloseDeleteModal,
    onApproveDeletion,
    title = 'Delete Item',
    message = 'Are you sure you want to delete the item?',
    isLoading = false
}: IDeleteModal) => {
    return (
        <Modal
            open={openDeleteModal}
            onClose={handleCloseDeleteModal}>
            <div className={'p-2 min-w-[500px]'}>
                <div className='border-b-2 border-slate-200 dark:border-gray-600 pb-2 my-1'>
                    <p className='font-medium text-slate-700 dark:text-primary-darkMode'>{title}</p>
                </div>
                <p className='my-2 dark:text-primary-darkMode'>{message}</p>
                <div className='flex flex-row justify-end gap-2 my-2'>
                    <Button
                        label='Cancel'
                        className='px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-100 dark:border-gray-600 dark:hover:bg-gray-800 dark:text-primary-darkMode'
                        onClickButton={handleCloseDeleteModal}
                        disabled={isLoading}
                    />
                    <Button
                        label={isLoading ? 'Deleting...' : 'Proceed'}
                        className='px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed'
                        onClickButton={onApproveDeletion}
                        dataQa={'delete-modal'}
                        disabled={isLoading}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default DeleteModal;